module.exports = __webpack_public_path__ + "img/research-services.349df75.png";